import { useEffect, useState } from "react";
import { PageHeader, EmptyState, Pill } from "@/components/ui-bits";
import { Clock, FileQuestion, Trash2, Download, Repeat } from "lucide-react";
import api, { API_BASE } from "@/lib/api";

export default function LiveExams() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/assessments").then(r => setItems(r.data));
  useEffect(load, []);

  const del = async (id) => {
    if (!window.confirm("Delete assessment?")) return;
    await api.delete(`/assessments/${id}`);
    load();
  };

  return (
    <div>
      <PageHeader title="Live Exams" subtitle="All currently scheduled and active assessments." />
      {items.length === 0 ? <EmptyState title="No assessments yet" hint="Create a test from 'Create Test'." /> : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map(a => {
            const allow = a.allow_reattempts !== false;
            const maxAtt = a.max_attempts;
            const reattemptLabel = !allow
              ? "Single attempt"
              : maxAtt
                ? `Up to ${maxAtt} attempts`
                : "Unlimited attempts";
            return (
            <div key={a.id} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`live-exam-${a.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="inline-flex w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
                    <span className="text-xs uppercase tracking-wider text-emerald-700 font-medium">Live</span>
                  </div>
                  <div className="mt-2 text-lg font-semibold text-slate-900">{a.title}</div>
                  <div className="text-xs text-slate-500 mt-1">Scheduled: {a.scheduled_at ? new Date(a.scheduled_at).toLocaleString() : "Open"}</div>
                </div>
                <div className="flex items-center gap-1">
                  <a
                    data-testid={`live-export-${a.id}`}
                    href={`${API_BASE}/assessments/${a.id}/export-questions`}
                    title="Export questions as CSV"
                    className="text-slate-600 hover:bg-slate-100 rounded-lg p-2">
                    <Download className="w-4 h-4" />
                  </a>
                  <button onClick={()=>del(a.id)} title="Delete assessment" className="text-red-600 hover:bg-red-50 rounded-lg p-2">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="mt-4 flex flex-wrap gap-2 text-sm text-slate-600">
                <span className="inline-flex items-center gap-1.5"><Clock className="w-4 h-4 text-slate-400" /> {a.duration} min</span>
                <span className="inline-flex items-center gap-1.5"><FileQuestion className="w-4 h-4 text-slate-400" /> {a.question_ids?.length || 0} questions</span>
                <Pill tone="blue">Pass ≥ {a.passing_marks}%</Pill>
                <Pill tone={allow ? "green" : "amber"}>
                  <Repeat className="inline-block w-3 h-3 mr-1 -mt-0.5" />
                  {reattemptLabel}
                </Pill>
              </div>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
